import * as UI from 'ui';
import * as Select from 'app/area/case/selectors';
import { Dummy } from 'app/infrastructure/ui/debug-render';
import * as AppEnhance from 'app/components/enhancers';
import * as UIEnhance from 'ui/common/enhancers';
import { ControlType } from 'app/infrastructure/ui';
import { ComponentIndex } from 'app/infrastructure/ui/types-uischema';

const Enhance = {...AppEnhance, ...UIEnhance};

export const embeddedReportModeComponents: ComponentIndex =  {

  [ControlType.NotImplemented]: {
    component: Dummy,
    configType: ControlType.NotImplemented
  },

  [ControlType.Tile]: {
    component: UI.Tile,
    selectors: [
      Select.primaryKeyFromContext(),
      Select.expandAll,
      Select.casePermissions,
      Select.editDocumentItemVisibility
    ],
    configType: ControlType.Tile
  },

  [ControlType.CompactTile]: {
    component: UI.CompactTile,
    selectors: [
      Select.primaryKeyFromContext(),
      Select.expandAll,
      Select.casePermissions,
      Select.editDocumentItemVisibility
    ],
    configType: ControlType.CompactTile
  },

  [ControlType.LinkHeading]: {
    component: UI.ExternalLinkHeading,
    enhancers: [Enhance.withClassNames('compact')],
    selectors: [Select.urlToCase({withBaseUrl: true, openNew: true})],
    configType: ControlType.LinkHeading
  },

  [ControlType.DisplayLink]: {
      component: UI.DisplayLink,
      enhancers: [Enhance.withProperty('urlOpenNew', true)],
      configType: ControlType.DisplayLink
  }

};
